export interface Props{
	filters: any
}
export interface CalendarItem {
  eventId: string
  guestImageIds: string[]
  organizer: string
  organizerImageId: string
  title: string
  startTime: string
  endTime: string
  invitationStatus: "Accepted" | "Rejected" | "Awaiting"
}

export interface Meeting {
  description: string
  endTime: string
  invitations: Invitation[]
  meetingUrl: string
  organizer: User
  startTime: string
  title: string
}

export interface Invitation {
  invitationId: string
  status: "Accepted" | "Rejected" | "Awaiting"
  guest: User
}

export interface User {
  firstName: string
	imageId: string
	isDeleted: boolean
  lastName: string
  location: string
  rocketUserId: string
  role: "Mentee" | "Mentor"
  userId: string
}

export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}